import Inventory from './Inventory';

export default class SearchResults {
  private readonly searchResults: Inventory[];

  constructor(...searchResults: Inventory[]) {
    this.searchResults = searchResults;
  }

  getSearchResults(): Inventory[] {
    return this.searchResults;
  }

  getInventory(id: number): Inventory {
    return this.searchResults[id];
  }
}
